import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Heart } from "lucide-react";
import Gallery from "./Gallery";

const GalleryPage = () => {
  const [showImages, setShowImages] = useState(false);
  const [sparklesCount, setSparklesCount] = useState(15);

  // Adjust sparkles based on screen size
  useEffect(() => {
    const handleResize = () => {
      setSparklesCount(window.innerWidth < 640 ? 8 : 15);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sparkles = Array.from({ length: sparklesCount }).map(() => ({
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 4 + 2,
    delay: Math.random() * 1.5,
  }));

  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-100 overflow-hidden">
      <AnimatePresence mode="wait">
        {!showImages ? (
          <motion.div
            key="landing"
            className="relative flex flex-col items-center text-center px-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Sparkles */}
            {sparkles.map((s, i) => (
              <motion.div
                key={i}
                className="absolute bg-pink-200 rounded-full opacity-60 pointer-events-none"
                style={{
                  width: s.size,
                  height: s.size,
                  top: `${s.y}%`,
                  left: `${s.x}%`,
                  filter: "blur(1px)",
                }}
                animate={{
                  y: [0, -10, 0],
                  opacity: [0.3, 0.8, 0.3],
                }}
                transition={{
                  duration: 2 + Math.random(),
                  repeat: Infinity,
                  delay: s.delay,
                }}
              />
            ))}

            {/* Heading */}
            <motion.h1
              className="text-3xl md:text-5xl font-extrabold text-gray-800 mb-8 leading-snug"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              Welcome to Our Beautiful Gallery
            </motion.h1>

            {/* Heart Button */}
            <motion.button
              className="p-10 rounded-full shadow-xl bg-gradient-to-tr from-pink-400 to-pink-600 text-white hover:scale-105 hover:shadow-2xl transition-all"
              onClick={() => setShowImages(true)}
              animate={{
                scale: [1, 1.15, 1],
                rotate: [0, 12, -12, 0],
              }}
              transition={{
                repeat: Infinity,
                duration: 1.8,
                ease: "easeInOut",
              }}
            >
              <Heart className="w-16 h-16 md:w-20 md:h-20" />
            </motion.button>

            <p className="mt-6 text-sm md:text-base text-gray-600 max-w-md">
              Click the heart to unlock a world of stunning visuals ✨
            </p>
          </motion.div>
        ) : (
          <motion.div
            key="gallery"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full"
          >
            <Gallery />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default GalleryPage;
